<template>
  <div v-if="images.length > 0" class="tw-space-y-4">
    <p class="tw-text-primary tw-text-xs tw-font-medium">{{ title }}</p>
    <div class="tw-grid tw-grid-cols-2 tw-gap-4 sm:tw-grid-cols-3 md:tw-grid-cols-4">
      <button
        v-for="image in images"
        :key="image.url"
        class="hover:tw-border-primary focus:tw-ring-primary tw-group tw-relative tw-aspect-square tw-overflow-hidden tw-rounded-lg tw-bg-muted tw-transition-all focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2"
        @click="handleImageSelect(image.url)"
      >
        <img :src="image.url" :alt="image.description || defaultAlt" :class="imageClass" @error="handleImageError" />
        <div :class="overlayClass"></div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BrandKitAsset } from '@/studio/brandKit/store/types';

const props = defineProps<{
  title: string;
  images: BrandKitAsset[];
  defaultAlt?: string;
  imageClass?: string;
  overlayClass?: string;
}>();

const emit = defineEmits<{
  select: [imageUrl: string];
}>();

function handleImageSelect(imageUrl: string) {
  emit('select', imageUrl);
}

function handleImageError(event: Event) {
  const img = event.target as HTMLImageElement;
  img.style.display = 'none';
}
</script>
